/**
 * ❤️🔥🦊🔥🦊🔥🦊🔥🦊❤️
 */
export const FirefoxSvg = () => {
	return (
		<svg
			fill='none'
			width='28'
			height='28'
			viewBox='0 0 28 28'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_7606_2999)'>
				<path
					d='M26.5725 9.37582C25.9829 7.95704 24.7868 6.42516 23.8501 5.94091C24.5182 7.23473 24.9818 8.62424 25.2245 10.06L25.2269 10.0828C23.6926 6.25744 21.0907 4.71506 18.9656 1.35648C18.8581 1.18666 18.7506 1.01649 18.6459 0.836865C18.5861 0.734273 18.5381 0.641835 18.4964 0.55675C18.4083 0.386074 18.3404 0.205697 18.2941 0.0192791C18.2941 0.0106768 18.291 0.00235273 18.2853 -0.00410528C18.2796 -0.0105633 18.2718 -0.0147032 18.2632 -0.0157353C18.2549 -0.0180296 18.246 -0.0180296 18.2377 -0.0157353C18.2359 -0.0157353 18.2331 -0.012584 18.231 -0.0118837C18.2289 -0.0111834 18.2244 -0.00803211 18.2212 -0.00663153L18.2265 -0.0157353C14.8178 1.98008 13.6613 5.6748 13.5549 7.52286C12.1936 7.61643 10.8921 8.11805 9.82022 8.9623C9.70838 8.86757 9.5915 8.77897 9.47008 8.69689C9.16086 7.61458 9.14768 6.46912 9.43191 5.37998C8.18012 5.9864 7.06783 6.84605 6.16542 7.90452H6.15912C5.62129 7.22279 5.65911 4.97486 5.68992 4.50532C5.53082 4.56926 5.37894 4.6499 5.23684 4.74587C4.76206 5.08473 4.31821 5.46495 3.91049 5.88209C3.44589 6.35314 3.02155 6.86228 2.64192 7.40416C1.76945 8.64106 1.15062 10.0382 0.821171 11.5156L0.802964 11.6052C0.777403 11.7246 0.685315 12.3226 0.669559 12.4525C0.669559 12.4627 0.667458 12.4721 0.666408 12.4823C0.547617 13.0997 0.474008 13.725 0.446167 14.3531L0.446167 14.4231C0.449142 17.821 1.72665 21.0942 4.02622 23.5957C6.32578 26.0973 9.48009 27.6452 12.8657 27.9335C16.2514 28.2219 19.622 27.2297 22.3115 25.1531C25.001 23.0764 26.8136 20.0664 27.3911 16.718C27.4139 16.5429 27.4325 16.3696 27.4528 16.1928C27.7323 13.8826 27.4297 11.5392 26.5725 9.37582ZM10.9316 19.9985C10.995 20.0289 11.0545 20.0619 11.1196 20.0909L11.1291 20.0969C11.0632 20.0654 10.9974 20.0326 10.9316 19.9985ZM25.228 10.0859V10.073L25.2304 10.0873L25.228 10.0859Z'
					fill='url(#paint0_linear_7606_2999)'
				/>
				<path
					d='M26.5725 9.37586C25.9829 7.95708 24.7868 6.4252 23.8501 5.94095C24.5182 7.23477 24.9818 8.62428 25.2245 10.06V10.073L25.2269 10.0874C26.2729 13.0805 26.1216 16.3622 24.8046 19.2464C23.2493 22.5836 19.4845 26.0042 13.5916 25.8379C7.22425 25.6575 1.6167 20.9327 0.568367 14.7443C0.377539 13.7684 0.568367 13.2737 0.664307 12.4806C0.533432 13.0966 0.460402 13.7235 0.446167 14.3532L0.446167 14.4232C0.449142 17.8211 1.72665 21.0942 4.02622 23.5958C6.32578 26.0973 9.48009 27.6452 12.8657 27.9336C16.2514 28.2219 19.622 27.2297 22.3115 25.1531C25.001 23.0765 26.8136 20.0665 27.3911 16.718C27.4139 16.543 27.4325 16.3696 27.4528 16.1928C27.7323 13.8826 27.4297 11.5393 26.5725 9.37586Z'
					fill='url(#paint1_radial_7606_2999)'
				/>
				<path
					d='M26.5725 9.37586C25.9829 7.95708 24.7868 6.4252 23.8501 5.94095C24.5182 7.23477 24.9818 8.62428 25.2245 10.06V10.073L25.2269 10.0874C26.2729 13.0805 26.1216 16.3622 24.8046 19.2464C23.2493 22.5836 19.4845 26.0042 13.5916 25.8379C7.22425 25.6575 1.6167 20.9327 0.568367 14.7443C0.377539 13.7684 0.568367 13.2737 0.664307 12.4806C0.533432 13.0966 0.460402 13.7235 0.446167 14.3532L0.446167 14.4232C0.449142 17.8211 1.72665 21.0942 4.02622 23.5958C6.32578 26.0973 9.48009 27.6452 12.8657 27.9336C16.2514 28.2219 19.622 27.2297 22.3115 25.1531C25.001 23.0765 26.8136 20.0665 27.3911 16.718C27.4139 16.543 27.4325 16.3696 27.4528 16.1928C27.7323 13.8826 27.4297 11.5393 26.5725 9.37586Z'
					fill='url(#paint2_radial_7606_2999)'
				/>
				<path
					d='M19.9779 10.9711C20.0073 10.9918 20.0346 11.0124 20.0623 11.0331C19.7214 10.4286 19.297 9.87522 18.8017 9.38917C14.5839 5.17064 17.6963 0.242362 18.2212 -0.0079905L18.2265 -0.0156937C14.8178 1.98013 13.6613 5.67484 13.5548 7.5229C13.7131 7.51205 13.87 7.49874 14.0317 7.49874C15.2412 7.50096 16.4285 7.82342 17.4729 8.43333C18.5173 9.04324 19.3816 9.91885 19.9779 10.9711Z'
					fill='url(#paint3_radial_7606_2999)'
				/>
				<path
					d='M14.0405 11.8136C14.0181 12.1511 12.8255 13.3153 12.4085 13.3153C8.54956 13.3153 7.92316 15.6497 7.92316 15.6497C8.09403 17.6154 9.46379 19.2345 11.1196 20.091C11.1953 20.1302 11.2719 20.1655 11.3486 20.2002C11.4814 20.259 11.6143 20.3134 11.7471 20.3634C12.3154 20.5645 12.9106 20.6793 13.5129 20.7041C20.2766 21.0213 21.5868 12.6157 16.7058 10.1766C17.8573 10.0268 19.0234 10.3099 19.9779 10.9711C19.3817 9.91884 18.5174 9.04323 17.473 8.43332C16.4285 7.82341 15.2412 7.50096 14.0318 7.49874C13.8707 7.49874 13.7131 7.51204 13.5549 7.5229C12.1936 7.61647 10.8922 8.11809 9.82024 8.96234C10.0272 9.13741 10.2607 9.37131 10.7527 9.85626C11.6735 10.7635 14.0353 11.7033 14.0405 11.8136Z'
					fill='url(#paint4_radial_7606_2999)'
				/>
				<path
					d='M14.0405 11.8136C14.0181 12.1511 12.8255 13.3153 12.4085 13.3153C8.54956 13.3153 7.92316 15.6497 7.92316 15.6497C8.09403 17.6154 9.46379 19.2345 11.1196 20.091C11.1953 20.1302 11.2719 20.1655 11.3486 20.2002C11.4814 20.259 11.6143 20.3134 11.7471 20.3634C12.3154 20.5645 12.9106 20.6793 13.5129 20.7041C20.2766 21.0213 21.5868 12.6157 16.7058 10.1766C17.8573 10.0268 19.0234 10.3099 19.9779 10.9711C19.3817 9.91884 18.5174 9.04323 17.473 8.43332C16.4285 7.82341 15.2412 7.50096 14.0318 7.49874C13.8707 7.49874 13.7131 7.51204 13.5549 7.5229C12.1936 7.61647 10.8922 8.11809 9.82024 8.96234C10.0272 9.13741 10.2607 9.37131 10.7527 9.85626C11.6735 10.7635 14.0353 11.7033 14.0405 11.8136Z'
					fill='url(#paint5_radial_7606_2999)'
				/>
				<path
					d='M9.18751 8.51101C9.29745 8.58104 9.38814 8.64196 9.46762 8.69694C9.15841 7.61462 9.14523 6.46917 9.42946 5.38002C8.17767 5.98645 7.06538 6.84609 6.16296 7.90456C6.22914 7.90281 8.19765 7.86745 9.18751 8.51101Z'
					fill='url(#paint6_radial_7606_2999)'
				/>
				<path
					d='M0.570136 14.7443C1.61742 20.9327 7.22602 25.6575 13.5934 25.8379C19.4863 26.0045 23.2511 22.5836 24.8064 19.2464C26.1233 16.3622 26.2746 13.0805 25.2287 10.0874V10.0744C25.2287 10.0642 25.2266 10.0583 25.2287 10.0614L25.2311 10.0842C25.7126 13.2274 24.1138 16.2726 21.6145 18.3318L21.6068 18.3493C16.737 22.3154 12.0766 20.7422 11.1333 20.1001C11.0675 20.0686 11.0016 20.0358 10.9358 20.0017C8.09648 18.6445 6.9235 16.0577 7.1749 13.8391C6.50091 13.8491 5.8385 13.6634 5.26793 13.3045C4.69735 12.9456 4.24311 12.4289 3.96023 11.8171C4.70555 11.3605 5.55539 11.1023 6.42875 11.0673C7.30211 11.0322 8.16991 11.2214 8.94943 11.6168C10.5565 12.3464 12.3853 12.4182 14.0447 11.8171C14.0395 11.7068 11.6778 10.7666 10.7569 9.85976C10.2649 9.37481 10.0314 9.14127 9.82444 8.96585C9.7126 8.87112 9.59572 8.78252 9.4743 8.70044C9.39376 8.64547 9.30307 8.58594 9.19418 8.51451C8.20432 7.87095 6.23581 7.90631 6.17069 7.90806H6.16438C5.62656 7.22633 5.66438 4.97841 5.69519 4.50887C5.53609 4.57281 5.38421 4.65344 5.24211 4.74942C4.76733 5.08827 4.32348 5.46849 3.91576 5.88563C3.44949 6.35536 3.02339 6.86333 2.64194 7.40421C1.76946 8.64111 1.15064 10.0382 0.821189 11.5156C0.814537 11.5433 0.332388 13.6511 0.570136 14.7443Z'
					fill='url(#paint7_radial_7606_2999)'
				/>
				<path
					d='M18.8024 9.38916C19.2979 9.87575 19.7222 10.4298 20.063 11.0348C20.1375 11.0912 20.2072 11.1472 20.2664 11.2015C23.3431 14.0377 21.731 18.0468 21.6109 18.3322C24.1103 16.273 25.7076 13.2278 25.2276 10.0845C23.6926 6.25747 21.0906 4.71509 18.9656 1.35651C18.8581 1.18669 18.7506 1.01652 18.6459 0.836899C18.5861 0.734307 18.5381 0.641869 18.4964 0.556784C18.4083 0.386108 18.3404 0.205732 18.294 0.0193134C18.2941 0.0107112 18.291 0.00238706 18.2853 -0.00407095C18.2796 -0.010529 18.2718 -0.0146689 18.2632 -0.0157009C18.2549 -0.0179953 18.246 -0.0179953 18.2377 -0.0157009C18.2359 -0.0157009 18.2331 -0.0125496 18.231 -0.0118494C18.2289 -0.0111491 18.2244 -0.00799778 18.2212 -0.0065972C17.6963 0.242355 14.5839 5.17063 18.8024 9.38916Z'
					fill='url(#paint8_radial_7606_2999)'
				/>
				<path
					d='M20.2643 11.1998C20.2051 11.1455 20.1355 11.0895 20.0609 11.0331C20.0332 11.0124 20.0059 10.9918 19.9765 10.9711C19.0219 10.3099 17.8559 10.0268 16.7044 10.1766C21.5854 12.6171 20.2759 21.0213 13.5114 20.7041C12.9091 20.6793 12.3139 20.5645 11.7457 20.3634C11.6128 20.3137 11.48 20.2593 11.3472 20.2002C11.2705 20.1652 11.1938 20.1302 11.1182 20.091L11.1276 20.0969C12.0709 20.7408 16.73 22.314 21.6012 18.3462L21.6089 18.3287C21.7304 18.0451 23.3424 14.0349 20.2643 11.1998Z'
					fill='url(#paint9_radial_7606_2999)'
				/>
				<path
					d='M7.92315 15.6497C7.92315 15.6497 8.54956 13.3153 12.4085 13.3153C12.8255 13.3153 14.0192 12.1511 14.0405 11.8136C12.3811 12.4147 10.5523 12.3429 8.94522 11.6133C8.1657 11.2179 7.29791 11.0287 6.42455 11.0638C5.55118 11.0988 4.70135 11.3569 3.95602 11.8136C4.2389 12.4254 4.69315 12.9421 5.26372 13.301C5.83429 13.6599 6.49671 13.8456 7.1707 13.8356C6.91929 16.0545 8.09227 18.6414 10.9316 19.9982C10.995 20.0286 11.0545 20.0615 11.1196 20.0906C9.46239 19.2345 8.09402 17.6154 7.92315 15.6497Z'
					fill='url(#paint10_radial_7606_2999)'
				/>
				<path
					d='M26.5725 9.37582C25.9829 7.95704 24.7868 6.42516 23.8501 5.94091C24.5182 7.23473 24.9818 8.62424 25.2245 10.06L25.2269 10.0828C23.6926 6.25744 21.0907 4.71506 18.9656 1.35648C18.8581 1.18666 18.7506 1.01649 18.6459 0.836865C18.5861 0.734273 18.5381 0.641835 18.4964 0.55675C18.4083 0.386074 18.3404 0.205697 18.2941 0.0192791C18.2941 0.0106768 18.291 0.00235273 18.2853 -0.00410528C18.2796 -0.0105633 18.2718 -0.0147032 18.2632 -0.0157353C18.2549 -0.0180296 18.246 -0.0180296 18.2377 -0.0157353C18.2359 -0.0157353 18.2331 -0.012584 18.231 -0.0118837C18.2289 -0.0111834 18.2244 -0.00803211 18.2212 -0.00663153L18.2265 -0.0157353C14.8178 1.98008 13.6613 5.6748 13.5549 7.52286C13.7131 7.51201 13.87 7.4987 14.0318 7.4987C15.2412 7.50092 16.4285 7.82337 17.4729 8.43328C18.5174 9.04319 19.3816 9.9188 19.9779 10.9711C19.0233 10.3099 17.8573 10.0268 16.7058 10.1766C21.5868 12.6171 20.2773 21.0213 13.5128 20.704C12.9105 20.6793 12.3153 20.5645 11.7471 20.3633C11.6142 20.3136 11.4814 20.2592 11.3486 20.2002C11.2719 20.1652 11.1952 20.1301 11.1196 20.0909L11.1291 20.0969C11.0632 20.0654 10.9974 20.0326 10.9316 19.9985C10.995 20.0289 11.0545 20.0619 11.1196 20.0909C9.46237 19.2345 8.09401 17.6154 7.92314 15.6497C7.92314 15.6497 8.54955 13.3153 12.4085 13.3153C12.8255 13.3153 14.0191 12.1511 14.0405 11.8135C14.0353 11.7032 11.6735 10.7631 10.7527 9.85622C10.2607 9.37127 10.0272 9.13772 9.82022 8.9623C9.70838 8.86757 9.5915 8.77897 9.47008 8.69689C9.16086 7.61458 9.14768 6.46912 9.43191 5.37998C8.18012 5.9864 7.06783 6.84605 6.16542 7.90452H6.15912C5.62129 7.22279 5.65911 4.97486 5.68992 4.50532C5.53082 4.56926 5.37894 4.6499 5.23684 4.74587C4.76206 5.08473 4.31821 5.46495 3.91049 5.88209C3.44589 6.35314 3.02155 6.86228 2.64192 7.40416C1.76945 8.64106 1.15062 10.0382 0.821171 11.5156L0.802964 11.6052C0.777403 11.7246 0.662906 12.331 0.646449 12.4613C0.646449 12.4711 0.646449 12.4511 0.646449 12.4613C0.541725 13.0873 0.474843 13.7191 0.446167 14.3531L0.446167 14.4231C0.449142 17.821 1.72665 21.0942 4.02622 23.5957C6.32578 26.0973 9.48009 27.6452 12.8657 27.9335C16.2514 28.2219 19.622 27.2297 22.3115 25.1531C25.001 23.0764 26.8136 20.0664 27.3911 16.718C27.4139 16.5429 27.4325 16.3696 27.4528 16.1928C27.7323 13.8826 27.4297 11.5392 26.5725 9.37582Z'
					fill='url(#paint11_linear_7606_2999)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_7606_2999'
					x1='24.7763'
					y1='4.32045'
					x2='2.24836'
					y2='26.0556'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.048' stopColor='#FFF44F' />
					<stop offset='0.111' stopColor='#FFE847' />
					<stop offset='0.225' stopColor='#FFC830' />
					<stop offset='0.368' stopColor='#FF980E' />
					<stop offset='0.401' stopColor='#FF8B16' />
					<stop offset='0.462' stopColor='#FF672A' />
					<stop offset='0.534' stopColor='#FF3647' />
					<stop offset='0.705' stopColor='#E31587' />
				</linearGradient>
				<radialGradient
					id='paint1_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(23.7353 3.09001) scale(28.2906 28.2906)'
				>
					<stop offset='0.129' stopColor='#FFBD4F' />
					<stop offset='0.186' stopColor='#FFAC31' />
					<stop offset='0.247' stopColor='#FF9D17' />
					<stop offset='0.283' stopColor='#FF980E' />
					<stop offset='0.403' stopColor='#FF563B' />
					<stop offset='0.467' stopColor='#FF3750' />
					<stop offset='0.71' stopColor='#F5156C' />
					<stop offset='0.782' stopColor='#EB0878' />
					<stop offset='0.86' stopColor='#E50080' />
				</radialGradient>
				<radialGradient
					id='paint2_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(13.3977 14.656) scale(28.2906 28.2906)'
				>
					<stop offset='0.3' stopColor='#960E18' />
					<stop offset='0.351' stopColor='#B11927' stopOpacity='0.74' />
					<stop offset='0.435' stopColor='#DB293D' stopOpacity='0.343' />
					<stop offset='0.497' stopColor='#F5334B' stopOpacity='0.094' />
					<stop offset='0.53' stopColor='#FF3750' stopOpacity='0' />
				</radialGradient>
				<radialGradient
					id='paint3_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(16.8083 -3.33019) scale(20.4953 20.4953)'
				>
					<stop offset='0.132' stopColor='#FFF44F' />
					<stop offset='0.252' stopColor='#FFDC3E' />
					<stop offset='0.506' stopColor='#FF9D12' />
					<stop offset='0.526' stopColor='#FF980E' />
				</radialGradient>
				<radialGradient
					id='paint4_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(10.2685 22.0456) scale(13.4704 13.4704)'
				>
					<stop offset='0.353' stopColor='#3A8EE6' />
					<stop offset='0.472' stopColor='#5C79F0' />
					<stop offset='0.669' stopColor='#9059FF' />
					<stop offset='1' stopColor='#C139E6' />
				</radialGradient>
				<radialGradient
					id='paint5_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(14.9436 12.3375) rotate(-13.5916) scale(7.14192 8.3614)'
				>
					<stop offset='0.206' stopColor='#9059FF' stopOpacity='0' />
					<stop offset='0.278' stopColor='#8C4FF3' stopOpacity='0.064' />
					<stop offset='0.747' stopColor='#7716A8' stopOpacity='0.45' />
					<stop offset='0.975' stopColor='#6E008B' stopOpacity='0.6' />
				</radialGradient>
				<radialGradient
					id='paint6_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(13.0405 1.93254) scale(9.69058 9.69058)'
				>
					<stop stopColor='#FFE226' />
					<stop offset='0.121' stopColor='#FFDB27' />
					<stop offset='0.295' stopColor='#FFC82A' />
					<stop offset='0.502' stopColor='#FFA930' />
					<stop offset='0.732' stopColor='#FF7E37' />
					<stop offset='0.792' stopColor='#FF7139' />
				</radialGradient>
				<radialGradient
					id='paint7_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(20.6575 -4.21409) scale(41.3453 41.3453)'
				>
					<stop offset='0.113' stopColor='#FFF44F' />
					<stop offset='0.456' stopColor='#FF980E' />
					<stop offset='0.622' stopColor='#FF5634' />
					<stop offset='0.716' stopColor='#FF3647' />
					<stop offset='0.904' stopColor='#E31587' />
				</radialGradient>
				<radialGradient
					id='paint8_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(17.1728 -1.91508) rotate(83.976) scale(30.303 19.8876)'
				>
					<stop stopColor='#FFF44F' />
					<stop offset='0.06' stopColor='#FFE847' />
					<stop offset='0.168' stopColor='#FFC830' />
					<stop offset='0.304' stopColor='#FF980E' />
					<stop offset='0.356' stopColor='#FF8B16' />
					<stop offset='0.455' stopColor='#FF672A' />
					<stop offset='0.57' stopColor='#FF3647' />
					<stop offset='0.737' stopColor='#E31587' />
				</radialGradient>
				<radialGradient
					id='paint9_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(12.8123 5.52186) scale(25.8126 25.8126)'
				>
					<stop offset='0.137' stopColor='#FFF44F' />
					<stop offset='0.48' stopColor='#FF980E' />
					<stop offset='0.592' stopColor='#FF5634' />
					<stop offset='0.655' stopColor='#FF3647' />
					<stop offset='0.904' stopColor='#E31587' />
				</radialGradient>
				<radialGradient
					id='paint10_radial_7606_2999'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(19.626 7.03255) scale(28.2517 28.2517)'
				>
					<stop offset='0.094' stopColor='#FFF44F' />
					<stop offset='0.231' stopColor='#FFE141' />
					<stop offset='0.509' stopColor='#FFAF1E' />
					<stop offset='0.626' stopColor='#FF980E' />
				</radialGradient>
				<linearGradient
					id='paint11_linear_7606_2999'
					x1='24.5056'
					y1='4.2042'
					x2='5.33663'
					y2='23.3728'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.167' stopColor='#FFF44F' stopOpacity='0.8' />
					<stop offset='0.266' stopColor='#FFF44F' stopOpacity='0.634' />
					<stop offset='0.489' stopColor='#FFF44F' stopOpacity='0.217' />
					<stop offset='0.6' stopColor='#FFF44F' stopOpacity='0' />
				</linearGradient>
				<clipPath id='clip0_7606_2999'>
					<rect width='28' height='28' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
